module.exports = __webpack_public_path__ + "static/media/n2.6238410f.jpg";